import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pageSamples } from '../data/content';
export function InsidePages() {
  const [index, setIndex] = useState<number>(0);
  const [direction, setDirection] = useState<number>(1);
  const total = pageSamples.length;
  const current = pageSamples[index];
  const go = (next: number) => {
    setDirection(next > index ? 1 : -1);
    setIndex((next + total) % total);
  };
  return <section id="inside-pages" className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-130" data-mp="31xnaxe76rbgu">
      <div className="mx-auto max-w-5xl" data-id="element-131" data-mp="2x52gqbkdawcs">
        <div className="mx-auto max-w-2xl text-center" data-id="element-132" data-mp="2x416g9b6edw4">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-133" data-mp="2s7kibf3z7zj1">
            Zajrzyj do środka
          </span>
          <h2 className="mt-5 font-display text-[1.8rem] font-black leading-tight tracking-tight text-ink sm:text-[2.6rem]" data-id="element-134" data-mp="3pnhjhjkh2dva">
            Zobacz materiały{' '}
            <span className="italic text-brand" data-id="element-135" data-mp="1mm2szs0fyrc6">od środka.</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-136" data-mp="1rl60dj3w99nb">
            Prawdziwe strony z pakietu — od ćwiczeń z barwy dla klasy 4 po
            analizę dzieła sztuki i pomoce wizualne.
          </p>
        </div>

        <div className="mt-12 grid gap-8 md:grid-cols-[minmax(0,1fr)_18rem] md:items-center" role="group" aria-roledescription="karuzela" aria-label="Przykładowe strony materiałów" tabIndex={0} onKeyDown={event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          go(index + 1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          go(index - 1);
        }
      }} data-id="element-137" data-mp="1hukv5ctpt6vf">
          <div className="relative flex h-[26rem] items-center justify-center overflow-hidden rounded-3xl bg-white p-4 shadow-soft sm:h-[34rem] sm:p-6" data-id="element-138" data-mp="2tasyhggz0m85">
            <AnimatePresence initial={false} mode="wait" custom={direction} data-id="element-139" data-mp="634yc7frjcer">
              <motion.img key={current.src} src={current.src} alt={`${current.title} — przykładowa strona, ${current.level}`} custom={direction} initial={{
              opacity: 0,
              x: direction * 32
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: direction * -32
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} className="h-full w-full object-contain" data-id="element-140" data-mp="12ze3cbtos6p" />
            </AnimatePresence>

            <button type="button" onClick={() => go(index - 1)} aria-label="Poprzednia strona" className="absolute left-2 top-1/2 inline-flex h-14 w-14 -translate-y-1/2 items-center justify-center rounded-full bg-brand text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:bg-brand-dark active:scale-95 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:left-4" data-id="element-141" data-mp="fyf14xdzjntl">
              <ChevronLeftIcon className="h-7 w-7" aria-hidden="true" data-id="element-142" data-mp="1g0lj9mz28wm9" />
            </button>
            <button type="button" onClick={() => go(index + 1)} aria-label="Następna strona" className="absolute right-2 top-1/2 inline-flex h-14 w-14 -translate-y-1/2 items-center justify-center rounded-full bg-brand text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:bg-brand-dark active:scale-95 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:right-4" data-id="element-143" data-mp="1ky4wqknxp5d5">
              <ChevronRightIcon className="h-7 w-7" aria-hidden="true" data-id="element-144" data-mp="28ohd8jx8wafc" />
            </button>
          </div>

          <div className="flex flex-col" data-id="element-145" data-mp="2csfd4wue9p9g">
            <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-146" data-mp="2hpfit6nc0q01">
              {current.level}
            </p>
            <h3 className="mt-2 font-display text-xl font-bold leading-snug text-ink" data-id="element-147" data-mp="241nkljyi8tx9">
              {current.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-ink/60" data-id="element-148" data-mp="1zzaegufuitzy">
              {current.caption}
            </p>
            <p className="mt-5 text-xs font-bold tabular-nums text-ink/40" data-id="element-149" data-mp="28toqmo52xoeu">
              {index + 1} / {total}
            </p>

            <ul className="mt-6 flex gap-3 overflow-x-auto pb-2 md:flex-wrap md:overflow-visible" data-id="element-150" data-mp="1l3ccuwn5kxgc">
              {pageSamples.map((page, pageIndex) => <li key={page.src} data-id="element-151" data-mp="1h4vep2lpmxb2" data-mpi={pageIndex}>
                  <button type="button" onClick={() => go(pageIndex)} aria-label={`Przejdź do: ${page.title}`} aria-current={pageIndex === index} className={`h-20 w-16 shrink-0 overflow-hidden rounded-lg border-2 bg-white transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 ${pageIndex === index ? 'border-brand' : 'border-ink/10 hover:border-ink/30'}`} data-id="element-152" data-mp="1v2ti5cyht9bs">
                    <img src={page.src} alt="" className="h-full w-full object-cover object-top" data-id="element-153" data-mp="eb81veofcyo4" />
                  </button>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}